var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"map-control",attrs:{"title":_vm.title},on:{"click":_vm.click}},[_c('img',{attrs:{"src":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }